import { render, staticRenderFns } from "./countriesChart.vue?vue&type=template&id=b6e6356a&scoped=true&"
import script from "./countriesChart.vue?vue&type=script&lang=js&"
export * from "./countriesChart.vue?vue&type=script&lang=js&"
import style0 from "./countriesChart.vue?vue&type=style&index=0&id=b6e6356a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e6356a",
  null
  
)

export default component.exports